var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThyroidMalignancies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.824844 19.925806",
    id: "svg46",
    width: 21,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .thyroid-malignancies-cls-1 {\n        clip-path: url(#clippath-6);\n      }\n\n      .thyroid-malignancies-cls-2 {\n        clip-path: url(#clippath-7);\n      }\n\n      .thyroid-malignancies-cls-3 {\n        clip-path: url(#clippath-4);\n      }\n\n      .thyroid-malignancies-cls-4 {\n        clip-path: url(#clippath-9);\n      }\n\n      .thyroid-malignancies-cls-5 {\n        clip-path: url(#clippath-10);\n      }\n\n      .thyroid-malignancies-cls-6 {\n        clip-path: url(#clippath-11);\n      }\n\n      .thyroid-malignancies-cls-7, .thyroid-malignancies-cls-8 {\n        fill: none;\n      }\n\n      .thyroid-malignancies-cls-9 {\n        clip-path: url(#clippath-1);\n      }\n\n      .thyroid-malignancies-cls-10 {\n        clip-path: url(#clippath-5);\n      }\n\n      .thyroid-malignancies-cls-11 {\n        clip-path: url(#clippath-8);\n      }\n\n      .thyroid-malignancies-cls-12 {\n        clip-path: url(#clippath-3);\n      }\n\n      .thyroid-malignancies-cls-13 {\n        clip-path: url(#clippath-12);\n      }\n\n      .thyroid-malignancies-cls-8 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .thyroid-malignancies-cls-14 {\n        clip-path: url(#clippath-2);\n      }\n\n      .thyroid-malignancies-cls-15 {\n        clip-path: url(#clippath-13);\n      }\n\n      .thyroid-malignancies-cls-16 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "thyroid-malignancies-cls-7",
    x: 62.049999,
    y: 4.0300002,
    width: 10.99,
    height: 19.93,
    id: "rect13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "thyroid-malignancies-cls-7",
    x: 71.889999,
    y: 4.0300002,
    width: 10.99,
    height: 19.93,
    id: "rect14"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(-62.055155,-4.0341937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "thyroid-malignancies-cls-13",
    clipPath: "url(#clippath-12)",
    id: "g41"
  }, /*#__PURE__*/React.createElement("line", {
    className: "thyroid-malignancies-cls-8",
    x1: 69.129997,
    y1: 23.17,
    x2: 72.290001,
    y2: 23.219999,
    id: "line40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thyroid-malignancies-cls-8",
    d: "M 69.06,21.23 C 69.15,22.28 69.14,23 69.14,23",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thyroid-malignancies-cls-8",
    d: "M 69.99,7.22 C 69.29,6.31 68.68,5.1 67.59,4.84 66.83,4.65 66.21,4.98 65.68,5.23 c -1.8,0.82 -2.48,2.52 -2.63,2.94 -0.28,0.77 -0.26,1.34 -0.23,1.66 0.03,0.31 0.08,0.71 0.37,1.06 0.18,0.22 0.38,0.34 0.69,0.52 0.38,0.22 0.51,0.22 0.91,0.43 0.19,0.1 0.46,0.25 0.78,0.49",
    id: "path41"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "thyroid-malignancies-cls-15",
    clipPath: "url(#clippath-13)",
    id: "g43"
  }, /*#__PURE__*/React.createElement("line", {
    className: "thyroid-malignancies-cls-8",
    x1: 75.800003,
    y1: 23.17,
    x2: 72.639999,
    y2: 23.219999,
    id: "line41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thyroid-malignancies-cls-8",
    d: "M 75.88,21.23 C 75.79,22.28 75.8,23 75.8,23",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thyroid-malignancies-cls-8",
    d: "m 74.95,7.22 c 0.7,-0.91 1.31,-2.12 2.4,-2.38 0.76,-0.19 1.38,0.14 1.91,0.39 1.8,0.82 2.48,2.52 2.63,2.94 0.28,0.77 0.26,1.34 0.23,1.66 -0.03,0.31 -0.08,0.71 -0.37,1.06 -0.18,0.22 -0.38,0.34 -0.69,0.52 -0.38,0.22 -0.51,0.22 -0.91,0.43 -0.19,0.1 -0.46,0.25 -0.78,0.49",
    id: "path43"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "thyroid-malignancies-cls-8",
    d: "m 79.1,16.21 c 0,1.26 -1.04,2.28 -2.32,2.28 -0.18,0 -0.33,0.15 -0.33,0.33 v 0.98 c 0,0.72 -0.59,1.3 -1.33,1.3 0,0 -0.66,-1.48 -0.66,-1.3 v 1.3 h -3.98 v -1.3 c 0,-0.18 -0.66,1.3 -0.66,1.3 -0.73,0 -1.33,-0.58 -1.33,-1.3 v -0.98 c 0,-0.18 -0.15,-0.33 -0.33,-0.33 -1.28,0 -2.32,-1.02 -2.32,-2.28 v -2.93 c 0,-1.82 0.79,-3.57 2.16,-4.81 1.24,-1.11 2.8,-1.71 4.46,-1.71 0.2,0 0.41,0 0.62,0.03 3.38,0.3 6.02,3.25 6.02,6.72 z M 69.71,11.3 c -0.87,0 -1.58,0.7 -1.58,1.55 0,0.85 0.71,1.55 1.58,1.55 0.87,0 1.58,-0.7 1.58,-1.55 0,-0.85 -0.71,-1.55 -1.58,-1.55 z m 5.53,0 c -0.87,0 -1.58,0.7 -1.58,1.55 0,0.85 0.71,1.55 1.58,1.55 0.87,0 1.58,-0.7 1.58,-1.55 0,-0.85 -0.71,-1.55 -1.58,-1.55 z m -1.83,6.29 c -0.1,0.1 -0.45,0.1 -0.76,0.1 h -0.36 c -0.31,0 -0.66,0 -0.76,-0.1 -0.05,-0.05 -0.06,-0.16 -0.06,-0.24 0,-0.67 0.53,-1.7 0.99,-1.7 0.46,0 0.99,1.03 0.99,1.7 0,0.08 0,0.2 -0.06,0.24 v 0 z",
    id: "path44"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThyroidMalignancies);
export default __webpack_public_path__ + "static/media/ThyroidMalignancies.7c8d1bf1fb3bb60ff240d783bed51e90.svg";
export { ForwardRef as ReactComponent };